import {useEffect, useState} from 'react';
import {Config, Recommendation, Track} from 'qon-connection';
import {useLazyQuery} from '@apollo/client';
import {GET_PRODUCT_SLIDER} from '../queries/misc';
import '../utils/base64Polyfill';
import {useConfig} from "../context/ConfigContext";

function getSkuList(products) {
  return products && products.map(x => x._id.trim()).join(',');
}


function getConditions(products) {
  const skuList=getSkuList(products)
  return JSON.stringify({filter:{sku:{eq:skuList}},pageSize:products.length,currentPage:1,sort:[]})
}



export const sendProductsQuarticon = (sku, tracker) => {
  if (!tracker) {
    return null;
  }
  return tracker.sendProductView({ id: sku });
};

const atob = base64 => {
  if (!base64) return null;
  if (typeof window !== 'undefined' && window.atob) {
    // For browser
    return window.atob(base64);
  } else if (typeof Buffer !== 'undefined') {
    // For Node.js
    return Buffer.from(base64, 'base64').toString('binary');
  } else {
    throw new Error('Environment does not support base64 decoding');
  }
};

export const sendTransactionQuarticon = (product, tracker) => {
  if (!tracker) {
    return null;
  }
  const { items, reserved_order_id } = product || {};

  const transaction = {
    transactionId: reserved_order_id,
    basket:
      items &&
      items.map(x => {
        return {
          productId: x.product.sku,
          price: x.product.prices[0].amount,
          quantity: x.quantity,
        };
      }),
  };
  return tracker.sendTransaction(transaction);
};

export const useRecommendationsQuarticon = (sku, type, categoryId) => {

  const [recomendations, setRecomendations] = useState([]);

  const [productsFromQuarticon, setProductsFromQuarticon] = useState([]);
  const [query, {data, loading}] = useLazyQuery(GET_PRODUCT_SLIDER, {
    onCompleted: (data) => {
      setRecomendations(data.productsByCondition.items);
    }
  });

  const { config } = useConfig();

  const quarticonConfig = config?.quarticon;

  const configQ = quarticonConfig && quarticonConfig.is_active &&
      new Config.Config({customerSymbol: quarticonConfig.customer_symbol, host: quarticonConfig.host_url});

  const tracker = configQ && new Track.Tracker(configQ);
  const recommendationEngine = configQ && new Recommendation.Recommendation(configQ);

  let filter = [];
  if (categoryId) {
    filter = [Recommendation.FilterApi.category(atob(categoryId))];
  } else if (sku) {
    filter = [Recommendation.FilterApi.product(sku)];
  } else {
    filter = [];
  }

  useEffect(() => {
    async function getData() {
      const widgetData = {
        placementId: quarticonConfig.widget_ids[type],
        filters: filter,
      };
      const products = await recommendationEngine.getRecommendation(widgetData);
      setProductsFromQuarticon(products);
      const skuList = getSkuList(products);
      query({variables: {condition: getConditions(products)}});
    }

    if (recommendationEngine) {
      getData().catch(console.error);
    }
  }, [categoryId, type]);
  return {recomendations: recomendations, loading};
};
